import { blockedAuthPaths } from '@manager/modules/auth/auth-route-paths';

const storageKey = 'auth-redirect-url';

export function useAuthRedirect() {
  function saveRedirectUrl(url: string) {
    if (blockedAuthPaths.some((path) => url.startsWith(path))) return;
    sessionStorage.setItem(storageKey, url);
  }

  function consumeRedirectUrl(): string | null {
    const url = sessionStorage.getItem(storageKey);
    sessionStorage.removeItem(storageKey);
    return url;
  }

  return { saveRedirectUrl, consumeRedirectUrl };
}
